export function chooseRandomFromList<T>(list: T[]): T {
	return list[Math.floor(Math.random() * list.length)];
}

export enum EmojiPageHeaderCohort {
	NOT_ENROLLED = 'not-enrolled',
	CONTROL = 'control',
	EMOJI = 'emoji',
	HEADER = 'header',
	EMOJI_AND_HEADER = 'emoji_and_header',
}
